import {
  updateLabelConfig,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
  attachCustomsInfoSelector,
  ADDITIONAL_DEPENDENT_PROPERTIES,
} from '../../../../data/labelInfos/index.js'
import ConfigCheckbox from '../ConfigCheckbox.js'
import {getState, useSelector} from '../../../../store.js'
import {FEDEX, FEDEX_360} from '../../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../../LabelConfigContext.js'

const VALID_SHIPPER_TYPES = [FEDEX, FEDEX_360]
const ETD_SERVICE_LABEL_PROPERTY = 'etd_service'
const ETD_SERVICE_DEFAULT_FALSE_LABEL_PROPERTY = 'etd_service_default_false'

function etdServiceLabelPropertiesFunc(shipperType, labelInfoID) {
  const attachCustomsInfo = attachCustomsInfoSelector(getState(), {labelInfoID})

  return attachCustomsInfo
    ? [
        shipperType === FEDEX
          ? ETD_SERVICE_LABEL_PROPERTY
          : ETD_SERVICE_DEFAULT_FALSE_LABEL_PROPERTY,
      ]
    : []
}

const ETD_SERVICE_DEPENDENT_PROPERTIES = [
  ...ADDITIONAL_DEPENDENT_PROPERTIES,
  LABEL_PROPERTY_ATTACH_CUSTOMS_INFO,
]

function dependentPropertiesFunc() {
  return ETD_SERVICE_DEPENDENT_PROPERTIES
}

const VALID_ETD_SERVICE_LABEL_PROPERTIES = [
  ETD_SERVICE_LABEL_PROPERTY,
  ETD_SERVICE_DEFAULT_FALSE_LABEL_PROPERTY,
]

export default function ETDService() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const [propertySpecs] = ETDService.propertySpecList
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  const attachCustomsInfo = useSelector((state) =>
    attachCustomsInfoSelector(state, {labelInfoID}),
  )

  return (
    <ConfigCheckbox
      label="FedEx® Electronic Trade Documents Service"
      onChange={(checked) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: checked})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      hide={!attachCustomsInfo}
    />
  )
}

ETDService.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: etdServiceLabelPropertiesFunc,
    dependentPropertiesFunc,
    validLabelPropertiesFunc() {
      return VALID_ETD_SERVICE_LABEL_PROPERTIES
    },
  },
]
